import { 
  CREATE_NEW_GET_ZIP_TIER,
  NEW_ZIP_TIER_SUCCESS,
  NEW_ZIP_TIER_ERROR,
  DELETE_ZIP_TIER,
  DELETE_ZIP_TIER_ERROR,
  DELETE_ZIP_TIER_SUCCESS,
  GET_ZIP_TIERS,
  GET_ZIP_TIERS_ERROR,
  GET_ZIP_TIERS_SUCCESS,
  MODIFY_ZIP_TIER_ERROR,
  MODIFY_ZIP_TIER_SUCCESS,
  MODIFY_ZIP_TIER
} from "./actionTypes"

const initialState = {
  loading_zip_tiers: false,
  zip_tiers: [],
  zip_tiers_error: null,
}

const ZipTiers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ZIP_TIERS:
      return {
        ...state,
        loading_zip_tiers: true,
      };
    case GET_ZIP_TIERS_SUCCESS:
      return {
        ...state,
        zip_tiers: action.payload,
        loading_zip_tiers: false,
      };
    case GET_ZIP_TIERS_ERROR:
      return {
        ...state,
        zip_tiers_error: action.payload,
        loading_zip_tiers: false,
      };
    case CREATE_NEW_GET_ZIP_TIER:
      return {
        ...state,
        loading_zip_tiers: true,
      };
    case NEW_ZIP_TIER_SUCCESS:
      return {
        ...state,
        zip_tiers: [...state.zip_tiers, action.payload],
        loading_zip_tiers: false,
      };
    case NEW_ZIP_TIER_ERROR:
      return {
        ...state,
        zip_tiers_error: action.payload,
        loading_zip_tiers: false,
      };
    case MODIFY_ZIP_TIER:
      return {
        ...state,
        loading_zip_tiers: true,
      };
    case MODIFY_ZIP_TIER_SUCCESS:
      return {
        ...state,
        zip_tiers: state.zip_tiers.map((zipTier) => {
          if (zipTier.id === action.payload.id) {
            return action.payload;
          }
          return zipTier;
        }),
        loading_zip_tiers: false,
      };
    case MODIFY_ZIP_TIER_ERROR:
      return {
        ...state,
        zip_tiers_error: action.payload,
        loading_zip_tiers: false,
      };
    case DELETE_ZIP_TIER:
      return {
        ...state,
        loading_zip_tiers: true,
      };
    case DELETE_ZIP_TIER_SUCCESS:
      return {
        ...state,
        zip_tiers: state.zip_tiers.filter(
          (zipTier) => zipTier.id !== action.payload.id
        ),
        loading_zip_tiers: false,
      };
    case DELETE_ZIP_TIER_ERROR:
      return {
        ...state,
        zip_tiers_error: action.payload,
        loading_zip_tiers: false,
      };
    default:
      return state
  }
}

export default ZipTiers;
